import React, { useState } from "react";
import { AddCircleOutline, MinusCircleOutline } from "antd-mobile-icons";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import "./Pdf.less";

interface PdfProps {
  pages?: number;
  url: string;
  onSuccess: (data: any) => void;
  width?: number;
  hideZoom?: boolean;
}

export default function Pdf({
  pages = 0,
  url,
  onSuccess,
  width: defaultWidth,
  hideZoom = false,
}: PdfProps) {
  const width = defaultWidth || (document.getElementById("root") as any)?.clientWidth;
  const [containerWidth, setContainerWidth] = useState<number>(width);

  const pageZoomOut = () => {
    if (containerWidth <= 200) return;
    const pageWidth = containerWidth - width * 0.1;
    setContainerWidth(pageWidth);
  };
  const pageZoomIn = () => {
    if (containerWidth >= 1000) return;
    const pageWidth = containerWidth + width * 0.1;
    setContainerWidth(pageWidth);
  };

  return (
    <div className="pdf-view" id="pdfView">
      {hideZoom ? null : (
        <div className="pdf-action">
          <span
            style={{ cursor: containerWidth >= 1000 ? "not-allowed" : "cursor" }}
            onClick={pageZoomIn}
          >
            <AddCircleOutline className="icon-zoom" />
          </span>
          <span
            style={{ cursor: containerWidth <= 200 ? "not-allowed" : "cursor" }}
            onClick={pageZoomOut}
          >
            <MinusCircleOutline className="icon-zoom" />
          </span>
        </div>
      )}

      {/* 更换PDF */}
      <Document
        file={url}
        loading="加载中..."
        error="加载失败"
        onLoadSuccess={onSuccess}
        className="pdf-viewer"
      >
        {new Array(pages).fill(1)?.map((_: number, page: number) => (
          <div key={page} className="pdf-item-wrap">
            <Page pageNumber={page + 1} width={containerWidth} />
            <span className="pdf-item-page">
              {page + 1}/{pages}
            </span>
          </div>
        ))}
      </Document>
    </div>
  );
}
